import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchTrainingProgramsAction } from "../../../interfaces/store/training-programs-interface";
import {
  fetchTrainingProgramsSuccess,
  fetchTrainingProgramsFailed,
  fetchTrainingProgramsStart,
} from "./training-programs-slice";
import { searchTrainingProgramsApi } from "../../../api/training-programs";

function* _fetchTrainingPrograms({ payload }: IFetchTrainingProgramsAction) {
  try {
    const { sort, filter, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchTrainingProgramsApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      filter,
      pagination,
    });

    if (response.error) {
      yield put(fetchTrainingProgramsFailed(response.error));
    } else {
      yield put(fetchTrainingProgramsSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchTrainingProgramsFailed({ message: error.message }));
  }
}

function* trainingProgramsSaga() {
  yield takeLatest(fetchTrainingProgramsStart.type, _fetchTrainingPrograms);
}

export default trainingProgramsSaga;
